export default "__VITE_ASSET__CCDl_gwU__"